<template>
    <transition
        v-bind:css="false"
        v-on:enter="enter"
        v-on:leave="leave">
        <div v-if="isDrawn">
            <form-element
                v-bind:class="classObject"
                v-bind:element="element" />
        </div>
    </transition>
</template>

<script>
    import element from "../Elements/element.vue";
    import { PROJECT_FORM_TYPES } from "./projectFormStore";
    import $ from "jquery";

    export default {
        components: { "form-element": element },
        props: {
            element: { type: Object, required: true }
        },
        data: function () {
            return {
                initialShow: true,
                shouldDraw: true
            };
        },
        computed: {
            isDrawn() {
                return this.shouldDraw && this.isVisible;
            },
            isVisible() {
                if (this.projectElement.IsVisible != null) {
                    return this.projectElement.IsVisible;
                }
                return false;
            },
            projectElement() {
                return this.$store.getters[PROJECT_FORM_TYPES.getters.projectElementFromId](this.element.PublicId);
            },
            classObject() {
                return {
                    "transition-bg": true,
                    "alert-danger": this.projectElement.hasValidationError
                };
            }
        },
        created() {
            // Can't just initialize this in data because projectElement
            // won't be defined yet
            this.initialShow = this.projectElement.IsVisible;

            // If batch drawing enabled, all elements hidden initially
            this.shouldDraw = !this.$store.getters[PROJECT_FORM_TYPES.getters.doBatchDrawElements];
        },
        methods: {
            enter(el, done) {
                if (this.initialShow) {
                    this.initialShow = false;
                } else {
                    const $el = $(el);
                    if ($el.is(":animated")) {
                        $el.slideDown(done);
                    } else {
                        $el.hide().slideDown(done);
                    }
                }
            },
            leave(el, done) {
                this.initialShow = false;
                $(el).slideUp(done);
            },
            // Hook to allow parent to programmatically render element
            // in case we want more control while rendering a large number
            // of elements.
            draw() {
                this.shouldDraw = true;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .transition-bg {
        transition: background-color 0.4s linear;
    }
</style>
